import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, MailIcon, PhoneIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-gray-900 text-white" data-id="element-81">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-82">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-83">
          <div data-id="element-84">
            <div className="flex items-center space-x-2 mb-4" data-id="element-85">
              <div className="w-10 h-10 bg-primary-500 rounded-md flex items-center justify-center" data-id="element-86">
                <span className="text-white font-bold text-xl" data-id="element-87">AI</span>
              </div>
              <span className="text-xl font-bold" data-id="element-88">科技企业</span>
            </div>
            <p className="text-gray-400 mb-4" data-id="element-89">
              专注于人工智能技术创新与应用，为企业提供先进的大模型服务、异构算力平台和智能解决方案。
            </p>
            <div className="flex space-x-4" data-id="element-90">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-91">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-92">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-93" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-94">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-95">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-96" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-97">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-98">
                  <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" data-id="element-99" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-100">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-101">
                  <path fillRule="evenodd" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c5.51 0 10-4.48 10-10S17.51 2 12 2zm6.605 4.61a8.502 8.502 0 011.93 5.314c-.281-.054-3.101-.629-5.943-.271-.065-.141-.12-.293-.184-.445a25.416 25.416 0 00-.564-1.236c3.145-1.28 4.577-3.124 4.761-3.362zM12 3.475c2.17 0 4.154.813 5.662 2.148-.152.216-1.443 1.941-4.48 3.08-1.399-2.57-2.95-4.675-3.189-5A8.687 8.687 0 0112 3.475zm-3.633.803a53.896 53.896 0 013.167 4.935c-3.992 1.063-7.517 1.04-7.896 1.04a8.581 8.581 0 014.729-5.975zM3.453 12.01v-.26c.37.01 4.512.065 8.775-1.215.25.477.477.965.694 1.453-.109.033-.228.065-.336.098-4.404 1.42-6.747 5.303-6.942 5.629a8.522 8.522 0 01-2.19-5.705zM12 20.547a8.482 8.482 0 01-5.239-1.8c.152-.315 1.888-3.656 6.703-5.337.022-.01.033-.01.054-.022a35.318 35.318 0 011.823 6.475 8.4 8.4 0 01-3.341.684zm4.761-1.465c-.086-.52-.542-3.015-1.659-6.084 2.679-.423 5.022.271 5.314.369a8.468 8.468 0 01-3.655 5.715z" clipRule="evenodd" data-id="element-102" />
                </svg>
              </a>
            </div>
          </div>
          <div data-id="element-103">
            <h3 className="text-lg font-semibold mb-4" data-id="element-104">快速链接</h3>
            <ul className="space-y-2" data-id="element-105">
              <li data-id="element-106">
                <Link to="/" className="text-gray-400 hover:text-white transition-colors" data-id="element-107">
                  首页
                </Link>
              </li>
              <li data-id="element-108">
                <Link to="/products" className="text-gray-400 hover:text-white transition-colors" data-id="element-109">
                  产品与服务
                </Link>
              </li>
              <li data-id="element-110">
                <Link to="/solutions" className="text-gray-400 hover:text-white transition-colors" data-id="element-111">
                  解决方案
                </Link>
              </li>
              <li data-id="element-112">
                <Link to="/cases" className="text-gray-400 hover:text-white transition-colors" data-id="element-113">
                  成功案例
                </Link>
              </li>
              <li data-id="element-114">
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors" data-id="element-115">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-116">
            <h3 className="text-lg font-semibold mb-4" data-id="element-117">联系方式</h3>
            <ul className="space-y-3" data-id="element-118">
              <li className="flex items-start" data-id="element-119">
                <MapPinIcon className="h-5 w-5 text-primary-400 mr-2 mt-0.5" data-id="element-120" />
                <span className="text-gray-400" data-id="element-121">
                  青岛市崂山区科技创新园12号楼
                </span>
              </li>
              <li className="flex items-center" data-id="element-122">
                <MailIcon className="h-5 w-5 text-primary-400 mr-2" data-id="element-123" />
                <a href="mailto:contact@aitech.com" className="text-gray-400 hover:text-white transition-colors" data-id="element-124">
                  contact@aitech.com
                </a>
              </li>
              <li className="flex items-center" data-id="element-125">
                <PhoneIcon className="h-5 w-5 text-primary-400 mr-2" data-id="element-126" />
                <a href="tel:+86-532-12345678" className="text-gray-400 hover:text-white transition-colors" data-id="element-127">
                  +86-532-12345678
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-128">
            <h3 className="text-lg font-semibold mb-4" data-id="element-129">办公地点</h3>
            <ul className="space-y-2" data-id="element-130">
              <li className="text-gray-400" data-id="element-131">青岛总部</li>
              <li className="text-gray-400" data-id="element-132">北京办公室</li>
              <li className="text-gray-400" data-id="element-133">上海办公室</li>
              <li className="text-gray-400" data-id="element-134">成都办公室</li>
              <li className="text-gray-400" data-id="element-135">多伦多办公室</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8" data-id="element-136">
          <p className="text-center text-gray-400" data-id="element-137">
            &copy; {new Date().getFullYear()} 科技企业. 保留所有权利.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;